<template>
    <div class="foot-wrapper">
        <div class="tabel-footer">
            <Checkbox name="allCheckBox" class="all-check" @valueChange="allCheckHandler" :data="allCheck" v-show="isShowAllCheck" />
            <label class="all-label" for="allCheckBox" v-show="isShowAllCheck">{{ $t("zhiji.common.selectAll") }}</label>
            <div class="all-buttons">
                <component
                    :is="btn.type || 'Button'"
                    class="btn"
                    v-for="(btn, idx) in buttons"
                    :key="idx"
                    @btnClick="btnClick"
                    :text="btn.text"
                    :icon="btn.icon"
                    :rightIcon="btn.rightIcon"
                    :addData="btn"
                    :hoverIcon="btn.hoverIcon"
                    :hoverIconRight="btn.hoverIconRight"
                    :options="btn.options"
                    :getOptions="btn.getOptions"
                />
            </div>
            <div class="page-rank" :class="{ 'page-rank-margin': buttons.length }">
                <PageLengthSelect
                    v-show="isShowLengthSelect"
                    :pageRank="config.pageLengthRank"
                    :curLength="pageLength"
                    @lengthChange="lengthChange"
                />
            </div>
        </div>
        <div class="page-control">
            <PageControl :total="total" :curPage="curPage" :lengthRank="config.pageLengthRank" :pageLength="pageLength" @pageChange="pageChange" />
        </div>
    </div>
</template>

<script>
import Checkbox from "@/views/zhiji/bComponents/checks/Checkbox";
import Button from "@/views/zhiji/bComponents/buttons/Button";
import OptionButton from "@/views/zhiji/bComponents/buttons/OptionButton";
import PageControl from "@/views/zhiji/bComponents/pageController/PageControl";
import PageLengthSelect from "@/views/zhiji/bComponents/pageController/PageLengthSelect";

/**
 * emit checkAll, emit btnClick, emit pageChange
 */
export default {
    name: "Footer",
    props: ["config", "total", "curPage", "allCheck"],
    components: {
        Checkbox,
        Button,
        OptionButton,
        PageControl,
        PageLengthSelect
    },
    computed: {
        buttons() {
            return this.config.bottomButtons || [];
        },
        isShowAllCheck() {
            return this.config.columns[0].type === "Checkbox";
        },
        isShowLengthSelect() {
            return !this.config.isHidePageLengthSelect;
        }
    },
    data() {
        return {
            pageLength: this.config.pageLength || 10
        };
    },
    methods: {
        btnClick(data) {
            this.$emit("btnClick", data);
        },
        lengthChange(pageLen) {
            this.pageLength = pageLen;
        },
        pageChange(page) {
            this.config.pageChange && this.config.pageChange.call(null, page);
            this.allCheckHandler({
                checked: false
            });

            this.$emit("pageChange", page);
        },
        allCheckHandler(data) {
            this.$emit("checkAll", data.checked);
        }
    }
};
</script>

<style lang="less" scoped>
.tabel-footer {
    width: 100%;
    background: #f2f7fb;
    padding: 8px 0 8px 20px;
    position: relative;
    color: rgba(65, 71, 94, 0.7);
    border-top: 1px solid #e3ecf5;
    border-bottom: 1px solid #e3ecf5;
    box-sizing: border-box;

    .all-check {
        position: relative;
        top: -3px;
        padding: 0px 15px 0px 0;
        box-sizing: border-box;
        display: inline-block;
    }

    .all-label {
        position: relative;
        top: -3px;
        margin-right: 20px;
    }

    .all-buttons {
        display: inline-block;
        .button-wrapper {
            height: 28px;
            line-height: 28px;
            vertical-align: top;
        }
    }

    .page-rank {
        float: right;
        margin: 0 30px 0 0;
    }

    .page-rank-margin {
        margin: 5px 30px 0 0;
        color: #41475e;
    }

    .btn {
        margin-right: 8px;
    }
}

.page-control {
    padding: 20px 0;
    text-align: center;
}
</style>
